const BASES_Y_CONDICIONES_TEXTO = `Concurso Literario y Artistico 2026 LA IDEA 111o Aniversario
(Los trabajos ganadores en Dibujo y Fotografia participaran de una exposicion
el dia de la premiacion)
28 vo. Concurso Nacional de Dibujo y Fotografia para Adultos,
Adolescentes y Ninos
Esta abierta la inscripcion para el 28 vo. Concurso Nacional de Fotografia y
Dibujo para Adultos (18 anos de edad en adelante), Adolescentes (12 a 17
anos de edad) y Ninos (8 a 11 anos de edad) que organiza este Multimedios,
cuya denominacion es LA IDEA 111o Aniversario.
La participacion es totalmente libre, debiendo el participante adulto abonar $
2.500 (los suscriptores $ 2.000) por derecho de inscripcion; adolescentes y
ninos SIN CARGO. Los tres mejores trabajos de cada disciplina obtendran una
medalla y un diploma -los que seran entregados el 9 de octubre de 2026- y la
publicacion de sus trabajos en UNA ANTOLOGIA. El colegio al que pertenezca
cada uno de los premiados en Ninos y Adolescentes recibira una bandera
argentina. La recepcion de los mismos (que deberan estar firmados con
seudonimo) vence EL 17 DE JULIO DE 2026, fecha a partir de la cual se
comenzara a evaluar por jurados especializados y nuestro director.
En Fotografia, las medidas no superaran los 20 x 25 cm., presentandose 3
ORIGINALES (NO FOTOCOPIAS; los trabajos presentados en fotocopia
quedaran fuera de concurso) en color, blanco y negro o sepia, acompanados
de una hoja con la explicacion del efecto buscado en la toma y su titulo.
Tambien podran ser presentados en formato digital.
En Dibujo, la medida no podra superar la hoja oficio, presentandose original y
dos copias, en tinta, acompanados de una hoja con la explicacion del motivo
buscado y su titulo. Tambien podran ser presentados en formato digital.
En las 2 disciplinas los participantes podran presentar hasta 3 trabajos cada
uno, debiendo (los adultos) abonar por cada uno. Los mismos deberan estar
acompanados por una hoja en la que figuren los datos personales del autor
(nombre, edad, domicilio, numero de documento, telefono, seudonimo, etc.).
ACLARAMOS: los datos enviados por las escuelas, deberan ser entregados en
papel carta con todos los datos solicitados, incluida la edad.
Para mayor informacion, los interesados deberan comunicarse las 24 horas al
telefono: (15) 5064-6321; o via mail a periodicolaidea1915@gmail.com; o
visitando nuestro Portal: www.multimedioslaidea.com.ar (ICONO
CONCURSOS).
NOTA: TODOS LOS TRABAJOS DEBERAN SER INDIVIDUALES.

LOS ORIGINALES NO SERAN DEVUELTOS.
35 to. Concurso Literario Nacional de Cuento Breve y Poesia para Adultos
Se encuentra abierta la inscripcion para el 35to. Concurso Literario Nacional de
Cuento Breve y Poesia para Adultos (18 anos de edad en adelante) que
organiza este Multimedios, cuya denominacion es LA IDEA 111o Aniversario.
La participacion es totalmente libre, debiendo el participante abonar $ 2.500
(los suscriptores $ 2.000) por derecho de inscripcion, por cada trabajo.
Los tres mejores trabajos de cada disciplina obtendran una medalla y un
diploma -los que seran entregados el 9 de octubre de 2026- y la publicacion de
sus trabajos en UNA ANTOLOGIA. La recepcion de los mismos (que deberan
estar firmados con seudonimo) vence el 17 DE JULIO DE 2026.
En el caso de Cuento, los trabajos no podran exceder de 4 carillas escritas con
interlineado doble. Las poesias no podran extenderse por mas de una carilla.
En ambos casos se debera escribir de un solo lado de la hoja y a maquina;
debiendo presentarse 3 copias de cada obra. En ambas disciplinas los
participantes podran presentar hasta tres trabajos cada uno, firmados con
seudonimo, debiendo abonar por cada uno. Los mismos deberan estar
acompanados por una hoja en la que figuren los datos personales del autor
(nombre, edad, domicilio, numero de documento, telefono, seudonimo, etc.).
Para mayor informacion, los interesados deberan comunicarse las 24 horas al
telefono: (15) 5064-6321; o via mail a periodicolaidea1915@gmail.com (ICONO
CONCURSOS).
NOTA: TODOS LOS TRABAJOS DEBERAN SER INDIVIDUALES.
LOS ORIGINALES NO SERAN DEVUELTOS.
33ro. Concurso Literario Nacional de Cuento Breve y Poesia para
Adolescentes
Esta abierta la inscripcion para el 33ro. Concurso Literario Nacional de Cuento
Breve y Poesia para Adolescentes (12 a 17 anos de edad) que organiza este
Multimedios y que hemos dado en llamar LA IDEA 111o Aniversario.
Podran participar jovenes que se encuentren cursando el nivel secundario. La
participacion es totalmente gratuita y cada participante podra presentar hasta
tres trabajos, debiendo firmarlos con seudonimo.
Los tres mejores trabajos de cada disciplina obtendran una medalla y un
diploma -los que seran entregados el 9 de octubre de 2026- y la publicacion de
sus trabajos en UNA ANTOLOGIA. El colegio a que pertenezca cada uno de
los premiados recibira una bandera argentina. La recepcion vence EL 17 DE
JULIO DE 2026.
En el caso de Cuento, los trabajos no podran excederse de 3 carillas con
interlineado doble. Las poesias no podran extenderse por mas de una carilla.
En todos los casos se debera escribir de un solo lado de la hoja y a maquina.
Se deben presentar 3 copias de cada obra. Los trabajos pueden ser
presentados en formato digital.
Los trabajos estaran acompanados por una hoja en la que figuren los datos
personales del autor (nombre, edad, domicilio, numero de documento, telefono,
seudonimo, etc.). ACLARAMOS: los datos enviados por las escuelas, deberan
ser entregados en papel carta con todos los datos solicitados, incluida la edad.
Para mayor informacion, los interesados deberan comunicarse las 24 horas al
telefono: (15) 5064-6321; o via mail a periodicolaidea1915@gmail.com.; o
visitando nuestro Portal: www.multimedioslaidea.com.ar (ICONO
CONCURSOS).
NOTA: TODOS LOS TRABAJOS DEBERAN SER INDIVIDUALES.
LOS ORIGINALES NO SERAN DEVUELTOS.
TODOS LOS TRABAJOS PUEDEN SER ENVIADOS POR MAIL, CON
SEUDONIMO, EDAD Y COLEGIO.
34to. Concurso Literario Nacional de Cuento Breve y Poesia para Ninos
Esta abierta la inscripcion para el 34to. Concurso Literario Nacional de Cuento
Breve y Poesia para Ninos (8 a 11 anos de edad) que organiza anualmente
nuestro Multimedios, cuya denominacion es LA IDEA 111o Aniversario.
Podran participar ninos que se encuentren cursando los ultimos tres anos de la
primaria (cuarto, quinto y sexto anos). La intervencion en el concurso es
totalmente gratuita. Podran presentar hasta 3 trabajos cada uno.
Los tres mejores trabajos de cada disciplina obtendran una medalla y un
diploma -los que seran entregados el 9 de octubre de 2026- y la publicacion de
su trabajo en UNA ANTOLOGIA. La escuela a la que pertenezca cada uno de
los premiados recibira una bandera argentina. La recepcion de trabajos vence
el 17 DE JULIO DE 2026.
En el caso de Cuento, los trabajos no podran exceder de 3 carillas, con
interlineado doble. Las poesias no podran extenderse por mas de una carilla.
En ambos casos, se podra escribir de un solo lado de la hoja y a maquina. Se
deben presentar 3 copias de cada obra.

Los trabajos deberan estar firmados con seudonimo y ser acompanados por
una hoja en la que figuren los datos personales del autor (nombre, edad,
domicilio, numero de documento, telefono, seudonimo, etc.).
ACLARAMOS: los datos enviados por las escuelas, deberan ser entregados en
papel carta con todos los datos solicitados, incluida la edad.
Para mayor informacion, los interesados deberan comunicarse las 24 horas al
telefono: (15) 5064-6321; o via mail a periodicolaidea1915@gmail.com; o
visitando nuestro Portal: www.multimedioslaidea.com.ar (ICONO
CONCURSOS).
NOTA: TODOS LOS TRABAJOS DEBERAN SER INDIVIDUALES. LOS
ORIGINALES NO SERAN DEVUELTOS.
TODOS LOS TRABAJOS PUEDEN SER ENVIADOS POR MAIL, CON
SEUDONIMO, EDAD Y COLEGIO.`;

export default BASES_Y_CONDICIONES_TEXTO;
